module.exports = __webpack_public_path__ + "0436cdb61f0aebd48fd620638169bfad.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/down-caret.png
// module id = V5Lr
// module chunks = 3